import React from "react";
import { RouteSafeBoundary } from "./RouteSafeBoundary";

export const wrapRouteElement = (element) => {
  if (element == null) {
    return element;
  }

  if (!React.isValidElement(element)) {
    return element;
  }

  return <RouteSafeBoundary>{element}</RouteSafeBoundary>;
};

export const wrapRoutes = (routes) =>
  routes.map((route) => {
    const wrapped = { ...route };

    if (wrapped.element) {
      wrapped.element = wrapRouteElement(wrapped.element);
    }

    if (wrapped.children?.length) {
      wrapped.children = wrapRoutes(wrapped.children);
    }

    return wrapped;
  });
